import { Log } from "../utils/debug";
import { axios } from "../utils/request";

export function apiGetCommentList() {
    Log.debug("GET: /api/comments");
    return axios.get("/comments");
}

export function apiDeleteComments(ids) {
    Log.debug("DELETE: /api/comments");
    return axios.delete("/comments", { data: { ids: ids } });
}

export function apiCheckComments(ids) {
    Log.debug("POST: /api/comments/check");
    return axios.post("/comments/check", { ids: ids });
}
